<div>
  @if (filters) {

    <app-area-select [(selectedArea)]="selectedArea" (selectedAreaChange)="onSearchArea($event)"></app-area-select>

    @for (fil of filters; track fil) {
<mat-form-field class="w-100" floatLabel="always">
      <mat-label>{{ fil.label | translate }}</mat-label>
      <mat-select [ngModel]="filter.get(fil.key)"
        (ngModelChange)="setFilter(fil.key, $event)" [multiple]="fil.multiple">
        @for (choice of fil.choices; track choice) {
<mat-option [value]="choice.value">{{choice.label | translate}}</mat-option>
}
      </mat-select>
    </mat-form-field>
}
  
}
</div>